import {put, takeLatest, call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";
import {
    UNDELETE_PROMOTION,
    GET_PROMOTIONS_SUCCESS,
    UNDELETE_PROMOTION_ERROR,
}
    from "../../../actions/menu/promotions";

function* unDeletePromotionSaga(action) {
    try {
        yield call(promotionService.UnDeletePromotion, action.payload)
        yield put({
            type: GET_PROMOTIONS_SUCCESS,
            payload: action.payload._id
        });

    } catch (error) {
        yield put({
            type: UNDELETE_PROMOTION_ERROR,error: error.data
        });
    }
}


export function* unDeletePromotionSagaWatcher() {
    yield takeLatest(UNDELETE_PROMOTION, unDeletePromotionSaga);
}